/**
 * Vietnamese Women's Day (20/10) marketing email starter.
 *
 * Assets are served from admin public after deploy:
 *   https://admin.wordsmine.com/email/...
 * CTA / extension link and course/Facebook URLs are constants below — edit there
 * (or the saved template HTML) if destinations should differ.
 */

const EMAIL_ASSET_BASE = 'https://admin.wordsmine.com/email'

export const VN_WOMENS_DAY_BANNER_URL = `${EMAIL_ASSET_BASE}/vn-womens-day-banner.jpg`
export const VN_WOMENS_DAY_FOOTER_URL = `${EMAIL_ASSET_BASE}/vn-womens-day-footer.jpg`
export const VN_WOMENS_DAY_ICON_LEARN_URL = `${EMAIL_ASSET_BASE}/icon-learn.png`
export const VN_WOMENS_DAY_ICON_SKILLS_URL = `${EMAIL_ASSET_BASE}/icon-skills.png`
export const VN_WOMENS_DAY_ICON_FUTURE_URL = `${EMAIL_ASSET_BASE}/icon-future.png`

/** Chrome extension / learning CTA (David's latest copy). */
export const VN_WOMENS_DAY_LEARNING_URL = 'https://wordsmine.com/extension'

export const VN_WOMENS_DAY_COURSE_URL =
	'https://app.wordsmine.com/course?category=32'
export const VN_WOMENS_DAY_FACEBOOK_URL =
	'https://www.facebook.com/wordsmine.official/'

export const VN_WOMENS_DAY_LOGO_URL = 'https://wordsmine.com/logo-lg.png'

const htmlBody = `<!DOCTYPE html>
<html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<title>Happy Vietnamese Women's Day</title>
<!--[if mso]>
<style type="text/css">
body, table, td { font-family: Georgia, 'Times New Roman', serif !important; }
</style>
<![endif]-->
<style type="text/css">
body { margin: 0 !important; padding: 0 !important; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
table, td { border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; display: block; }
a { text-decoration: none; }
@media only screen and (max-width: 620px) {
  .email-container { width: 100% !important; max-width: 100% !important; }
  .stack-column { display: block !important; width: 100% !important; max-width: 100% !important; }
  .stack-column-pad { padding-left: 0 !important; padding-right: 0 !important; padding-bottom: 20px !important; }
  .hero-pad { padding: 16px 20px 8px 20px !important; }
  .body-pad { padding: 24px 20px !important; }
  .value-wrap { padding: 20px 16px !important; }
}
</style>
</head>
<body style="margin:0;padding:0;background-color:#eef3f8;">
<div style="display:none;font-size:1px;line-height:1px;max-height:0;max-width:0;opacity:0;overflow:hidden;mso-hide:all;">
Keep Growing. Keep Blooming. Keep Discovering. Happy Vietnamese Women's Day from WordsMine.
</div>
<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color:#eef3f8;">
<tr>
<td align="center" style="padding:24px 12px;">
<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="600" class="email-container" style="width:600px;max-width:600px;background-color:#ffffff;border-radius:16px 16px 0 0;">

<!-- Logo bar -->
<tr>
<td class="hero-pad" align="left" bgcolor="#7e93a8" style="background-color:#7e93a8;padding:18px 28px 10px 28px;border-radius:16px 16px 0 0;">
<table role="presentation" cellpadding="0" cellspacing="0" border="0">
<tr>
<td style="vertical-align:middle;padding-right:10px;">
<img src="${VN_WOMENS_DAY_LOGO_URL}" width="36" height="36" alt="WordsMine" style="width:36px;height:36px;border-radius:50%;" />
</td>
<td style="vertical-align:middle;font-family:Arial,Helvetica,sans-serif;font-size:18px;font-weight:700;color:#eaf2f8;letter-spacing:0.2px;">
WordsMine
</td>
</tr>
</table>
</td>
</tr>

<!-- Hero banner (title + date + tagline + floral art baked into image) -->
<tr>
<td bgcolor="#7e93a8" style="background-color:#7e93a8;padding:0;">
<img src="${VN_WOMENS_DAY_BANNER_URL}" width="600" alt="Happy Vietnamese Women's Day — 20 October 2026. Keep Growing. Keep Blooming. Keep Discovering." style="width:100%;max-width:600px;height:auto;" />
</td>
</tr>

<!-- Body copy -->
<tr>
<td class="body-pad" style="padding:32px 36px 8px 36px;font-family:Arial,Helvetica,sans-serif;color:#2c3e50;font-size:15px;line-height:1.65;">
<p style="margin:0 0 16px 0;font-size:16px;font-weight:700;color:#243447;">Dear WordsMiners,</p>
<p style="margin:0 0 16px 0;">Today, we celebrate the incredible women who inspire us with their curiosity, resilience, kindness, and constant drive to grow.</p>
<p style="margin:0 0 16px 0;">Remember when someone encouraged you just when you needed it most, inspired you to see things differently, or simply made you feel that you weren't alone? The world would be a little less beautiful without the incredible women who bring us that comfort, spark our creativity, and fill our communities with warmth and kindness.</p>
<p style="margin:0 0 16px 0;">May you always receive the encouragement and support you deserve, pursue your dreams with confidence, discover new horizons with curiosity, and the courage to become everything you aspire to be.</p>
<p style="margin:0 0 16px 0;">At WordsMine, we believe learning should empower everyone, especially women, to thrive in their careers and lives.</p>
<p style="margin:0 0 8px 0;font-weight:600;color:#3a5f7a;">Wishing you a joyful and inspiring Vietnamese Women's Day! &#128144;</p>
</td>
</tr>

<!-- Value columns -->
<tr>
<td style="padding:12px 28px 8px 28px;">
<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color:#e8f3fb;border-radius:14px;">
<tr>
<td class="value-wrap" style="padding:24px 18px;">
<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%">
<tr>
<!-- Col 1 -->
<td class="stack-column stack-column-pad" width="33.33%" valign="top" style="width:33.33%;padding:0 10px;text-align:center;font-family:Arial,Helvetica,sans-serif;">
<table role="presentation" cellpadding="0" cellspacing="0" border="0" align="center" style="margin:0 auto 12px auto;">
<tr>
<td align="center">
<img src="${VN_WOMENS_DAY_ICON_LEARN_URL}" width="44" height="44" alt="" style="width:44px;height:44px;display:block;margin:0 auto;border:0;" />
</td>
</tr>
</table>
<div style="font-size:14px;font-weight:700;color:#1f3a4d;margin:0 0 6px 0;">Learn anytime</div>
<div style="font-size:13px;line-height:1.45;color:#5a6f82;">Explore new words at your own pace.</div>
</td>
<!-- Col 2 -->
<td class="stack-column stack-column-pad" width="33.33%" valign="top" style="width:33.33%;padding:0 10px;text-align:center;font-family:Arial,Helvetica,sans-serif;">
<table role="presentation" cellpadding="0" cellspacing="0" border="0" align="center" style="margin:0 auto 12px auto;">
<tr>
<td align="center">
<img src="${VN_WOMENS_DAY_ICON_SKILLS_URL}" width="44" height="44" alt="" style="width:44px;height:44px;display:block;margin:0 auto;border:0;" />
</td>
</tr>
</table>
<div style="font-size:14px;font-weight:700;color:#1f3a4d;margin:0 0 6px 0;">Build new skills</div>
<div style="font-size:13px;line-height:1.45;color:#5a6f82;">Grow with confidence every day.</div>
</td>
<!-- Col 3 -->
<td class="stack-column" width="33.33%" valign="top" style="width:33.33%;padding:0 10px;text-align:center;font-family:Arial,Helvetica,sans-serif;">
<table role="presentation" cellpadding="0" cellspacing="0" border="0" align="center" style="margin:0 auto 12px auto;">
<tr>
<td align="center">
<img src="${VN_WOMENS_DAY_ICON_FUTURE_URL}" width="44" height="44" alt="" style="width:44px;height:44px;display:block;margin:0 auto;border:0;" />
</td>
</tr>
</table>
<div style="font-size:14px;font-weight:700;color:#1f3a4d;margin:0 0 6px 0;">A brighter future</div>
<div style="font-size:13px;line-height:1.45;color:#5a6f82;">More opportunities for the life you want.</div>
</td>
</tr>
</table>
</td>
</tr>
</table>
</td>
</tr>

<!-- Explore more -->
<tr>
<td class="body-pad" style="padding:20px 36px 8px 36px;font-family:Arial,Helvetica,sans-serif;color:#2c3e50;font-size:15px;line-height:1.65;">
<p style="margin:0 0 10px 0;font-size:16px;font-weight:700;color:#243447;">Explore more with WordsMine &#128153;</p>
<p style="margin:0 0 14px 0;">Discover courses on wellbeing and emotional intelligence, and follow us for updates on courses, youth initiatives, and new opportunities.</p>
<p style="margin:0 0 8px 0;">
<a href="${VN_WOMENS_DAY_COURSE_URL}" target="_blank" style="color:#2b8fd6;font-weight:600;text-decoration:underline;">Explore Wellbeing &amp; EQ Courses</a>
</p>
<p style="margin:0 0 8px 0;">
<a href="${VN_WOMENS_DAY_FACEBOOK_URL}" target="_blank" style="color:#2b8fd6;font-weight:600;text-decoration:underline;">Follow us on Facebook</a>
</p>
</td>
</tr>

<!-- CTA -->
<tr>
<td align="center" style="padding:20px 36px 4px 36px;">
<p style="margin:0 0 14px 0;font-family:Arial,Helvetica,sans-serif;font-size:15px;line-height:1.5;color:#2c3e50;font-weight:600;">Continue your learning journey:</p>
<table role="presentation" cellpadding="0" cellspacing="0" border="0" align="center">
<tr>
<td align="center" bgcolor="#2b8fd6" style="border-radius:28px;background:linear-gradient(90deg,#2b8fd6 0%,#2aa8b8 100%);background-color:#2b8fd6;">
<a href="${VN_WOMENS_DAY_LEARNING_URL}" target="_blank" style="display:inline-block;padding:14px 28px;font-family:Arial,Helvetica,sans-serif;font-size:15px;font-weight:700;color:#ffffff;text-decoration:none;border-radius:28px;">Continue your learning journey &rarr;</a>
</td>
</tr>
</table>
</td>
</tr>

<!-- Sign-off -->
<tr>
<td class="body-pad" style="padding:18px 36px 12px 36px;font-family:Arial,Helvetica,sans-serif;font-size:15px;line-height:1.6;color:#2c3e50;">
With appreciation,<br />
<strong style="color:#1f3a4d;">The WordsMine Team</strong>
</td>
</tr>

</table>

<!-- Decorative florals: own block BELOW card content, ABOVE legal strip (no overlay / no overflow clip) -->
<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="600" class="email-container" style="width:600px;max-width:600px;background-color:#ffffff;border-radius:0 0 16px 16px;">
<tr>
<td align="center" style="padding:0;margin:0;line-height:0;font-size:0;background-color:#ffffff;border-radius:0 0 16px 16px;">
<img src="${VN_WOMENS_DAY_FOOTER_URL}" width="600" alt="" style="width:100%;max-width:600px;height:auto;display:block;border:0;outline:none;" />
</td>
</tr>
</table>

<!-- Legal footer: separate table under florals, gray bg so it never covers the art -->
<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="600" class="email-container" style="width:600px;max-width:600px;background-color:#eef3f8;">
<tr>
<td align="center" bgcolor="#eef3f8" style="padding:16px 12px 8px 12px;font-family:Arial,Helvetica,sans-serif;font-size:11px;line-height:1.4;color:#8a9aab;background-color:#eef3f8;">
You're receiving this because you have an account with WordsMine.<br />
<a href="https://app.wordsmine.com/" style="color:#5b8fb5;text-decoration:underline;">app.wordsmine.com</a>
</td>
</tr>
</table>
</td>
</tr>
</table>
</body>
</html>`

const textBody = `Happy Vietnamese Women's Day — 20 October 2026

Keep Growing. Keep Blooming. Keep Discovering.

Dear WordsMiners,

Today, we celebrate the incredible women who inspire us with their curiosity, resilience, kindness, and constant drive to grow.

Remember when someone encouraged you just when you needed it most, inspired you to see things differently, or simply made you feel that you weren't alone? The world would be a little less beautiful without the incredible women who bring us that comfort, spark our creativity, and fill our communities with warmth and kindness.

May you always receive the encouragement and support you deserve, pursue your dreams with confidence, discover new horizons with curiosity, and the courage to become everything you aspire to be.

At WordsMine, we believe learning should empower everyone, especially women, to thrive in their careers and lives.

Wishing you a joyful and inspiring Vietnamese Women's Day! 💐

• Learn anytime — Explore new words at your own pace.
• Build new skills — Grow with confidence every day.
• A brighter future — More opportunities for the life you want.

Explore more with WordsMine 💙

Discover courses on wellbeing and emotional intelligence, and follow us for updates on courses, youth initiatives, and new opportunities.

Explore Wellbeing & EQ Courses: ${VN_WOMENS_DAY_COURSE_URL}
Follow us on Facebook: ${VN_WOMENS_DAY_FACEBOOK_URL}

Continue your learning journey: ${VN_WOMENS_DAY_LEARNING_URL}

With appreciation,
The WordsMine Team`

export const vnWomensDay2026Template = {
	id: 'vn-womens-day-2026',
	name: "Vietnamese Women's Day",
	slug: 'vn-womens-day-2026',
	emailType: 'marketing',
	status: 'active',
	subject: "Happy Vietnamese Women's Day from WordsMine 💐",
	htmlBody,
	textBody,
}

export const EMAIL_STARTER_TEMPLATES = [vnWomensDay2026Template]
